<template>
  <div class="cmp-b2b-royalty-home-container">
    <div class="home-container">
      <div class="table-container">
        <div v-if="is_loaded_home_page_data" class="message-content">
          <div class="text-content">
            {{
              b2b_message_area
                ? b2b_message_area
                : $t("detailsb2b_default_message").replace(
                    "$display_name$",
                    displayName
                  )
            }}
            <!-- {{ $t("detailsb2b_default_message") }} -->
          </div>
        </div>
        <div v-if="is_loaded_home_page_data" class="table-content">
          <span class="table-header">{{
            $t("detailsb2b_latest_statements")
          }}</span>
          <LatestStatementTable :items="latest_statements" />
        </div>
      </div>
      <div class="chart-container">
        <div v-if="is_loaded_home_page_data" class="chart-content">
          <span class="chart_header_content">
            <span class="chart_header"
              >{{ $t("detailsb2b_monthly_income_24_last_months") }}
            </span>
            <MenuButton
              @click="onMenuClicked"
              :options="reportkeys"
              :label="label"
            />
          </span>
          <LineChart
            :default_currency="default_currency"
            v-if="is_loaded_channel_data"
            :chartdata="channelReportData"
            :appDrawer="appDrawer"
          />
        </div>
        <div v-if="is_loaded_home_page_data" class="table-content">
          <span class="table-header">{{ $t("detailsb2b_top_release") }}</span>
          <TopReleaseTable
            :default_currency="default_currency"
            :items="topReleaseReportData"
          />
        </div>
        <div v-if="is_loaded_home_page_data" class="table-content">
          <span class="table-header">{{ $t("detailsb2b_top_tracks") }}</span>
          <TopTracksTable
            :default_currency="default_currency"
            :items="topTracksReportData"
          />
        </div>

        <!-- <div v-if="is_loaded_home_page_data" class="chart-content">
          <span class="chart_header">{{
            $t("detailsb2b_monthly_income_24_last_month")
          }}</span>
          <BarChart
            :chartdata="releaseReportData"
            :appDrawer="appDrawer"
            :title="$t('detailsb2b_monthly_income_24_last_month')"
          />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { B2BStoreNamespace as storeNS } from "../../store/index";
import { mapGetters, mapActions } from "vuex";
import { clientId } from "../../services/http-client";
import * as types from "../../store/types";
import { GChart } from "vue-google-charts";
import BarChart from "../charts/bar-chart";
import LineChart from "../charts/line-chart";
import Chart from "chart.js";
import LatestStatementTable from "./latest-statements-table";
import TopReleaseTable from "./release-table.vue";
import TopTracksTable from "./tracks-table.vue";
import MenuButton from "./menuButton.vue";

export default {
  components: {
    GChart,
    BarChart,
    LineChart,
    LatestStatementTable,
    TopReleaseTable,
    TopTracksTable,
    MenuButton,
  },

  data() {
    return {
      clientId: clientId,
      label: "all",
    };
  },
  mounted() {
    this[types.B2B_FETCH_HOME_PAGE_CHART]();
  },
  computed: {
    ...mapGetters(storeNS, {
      user: "user",
      b2b_message_area: "b2b_message_area",
      display_name: "display_name",
      latest_statements: "latest_statements",
      release_report_data: "release_report_data",
      channel_report_data: "channel_report_data",
      top_release_report_data: "top_release_report_data",
      is_loaded_home_page_data: "is_loaded_home_page_data",
      top_tracks_report_data: "top_tracks_report_data",
      report_keys: "report_keys",
      appDrawer: "appDrawer",
      is_loaded_channel_data: "is_loaded_channel_data",
    }),
    default_currency:function(){
       return this.user?.system_currency||'';
    },
    displayName: function () {
      return this.display_name || "";
    },
    topReleaseReportData: function () {
      return this.top_release_report_data
        ? this.top_release_report_data.sort(
            (a, b) => parseFloat(a.top) - parseFloat(b.top)
          )
        : [];
    },
    topTracksReportData: function () {
      return this.top_tracks_report_data
        ? this.top_tracks_report_data.sort(
            (a, b) => parseFloat(a.top) - parseFloat(b.top)
          )
        : [];
    },
    reportkeys: function () {
      return this.report_keys.map((k) => {
        return {
          text: k,
          value: k,
        };
      });
    },
    releaseReportData: function () {
      if (!this.release_report_data) {
        return {};
      }

      let report = {
        labels: [],
        datasets: [
          {
            label: "Monthly Income 24 last months",
            backgroundColor: "#4FE890",
            data: [],
            barThickness: 8,
            barPercentage: 0.5,
            xAxis: {
              labels: {
                useHTML: true,
                style: {
                  width: 100,
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },
              },
            },
          },
        ],
      };
      this.release_report_data.forEach((c) => {
        c.subtotal = parseFloat(c.subtotal.replace(/\,/g, ""));
        c.name = `${c.item_name1}-${c.item_name2}`;
        report.labels.push(c.name);
        report.datasets[0].data.push(c.subtotal);
      });

      return report;
    },

    channelReportData: function () {
      console.log("this.channel_report_data", this.channel_report_data);
      if (!this.channel_report_data) {
        return {};
      }
      let report = {
        labels: [],
        datasets: [
          {
            label: "Monthly Income 24 last months",
            borderColor: "#4FE890",
            pointBackgroundColor: "#282828",
            pointBorderColor: "#282828",
            data: [],
          },
        ],
      };
      let data = this.channel_report_data.map((c) => {
        c.period = c.period.replace(/\M/g, "");
        c.year = c.period.split("-")[0];
        return c;
      });
      let years = data.map((p) => p.year);
      years = [...new Set(years)];
      let months = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ];
      let datatList = [];
      years.forEach((y) => {
        months.forEach((m, index) => {
          let yMonth = `${y.split("-")[0]}-${m}`;
          if (!data.find((p) => p.period == yMonth)) {
            datatList.push({
              period: yMonth,
              subtotal: "0",
            });
          } else {
            datatList.push({
              period: yMonth,
              subtotal: data.find((p) => p.period == yMonth).subtotal,
            });
          }
        });
      });

      datatList.forEach((c) => {
        report.labels.push(c.period);
        c.subtotal = parseFloat(c.subtotal.replace(/\,/g, ""));
        report.datasets[0].data.push(c.subtotal);
      });
      console.log("report", report);
      return report;
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [types.B2B_FETCH_HOME_PAGE_CHART]: types.B2B_FETCH_HOME_PAGE_CHART,
      [types.B2B_FETCH_FILTERED_CHANNEL_CHART]:
        types.B2B_FETCH_FILTERED_CHANNEL_CHART,
    }),
    onChartReady(chart, google) {
      this.chartsLib = google;
    },
    onMenuClicked(item) {
      console.log(item);
      this.label = item.text;
      this[types.B2B_FETCH_FILTERED_CHANNEL_CHART](item.value);
    },
  },
};
</script>

<style lang="scss">
.cmp-b2b-royalty-home-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: calc(100vh - 120px);
  .home-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    .table-container {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      flex-wrap: wrap;
      width: 100%;
      position: relative;
      gap: 1rem;
      margin-top: 20px;
      .message-content {
        display: flex;
        border: 1px solid #fff;
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 10px 30px #00000015;
        border-radius: 15px;
        opacity: 1;
        margin: 10px;
        padding: 0px 20px;
        overflow: auto;
        flex-direction: column;
        .table-header {
          color: #282828;
          font-size: 14px;
          margin-top: 22px;
          padding-bottom: 20px;
          font-weight: bold;
        }

        .text-content {
          font-size: 16px;
          font-weight: 400;
          text-align: center;
          justify-content: flex-start;
          display: flex;
          flex-direction: column;
          padding: 10px;
          flex: 1;
          align-items: center;
          white-space: pre-wrap;
        }
      }
      .table-content {
        display: flex;
        border: 1px solid #fff;
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 10px 30px #00000015;
        border-radius: 15px;
        opacity: 1;
        margin: 10px;
        padding: 0px 20px;
        overflow: auto;
        flex-direction: column;
        height: 350px !important;
        .table-header {
          color: #282828;
          font-size: 14px;
          margin-top: 22px;
          padding-bottom: 20px;
          font-weight: bold;
        }
      }
    }

    .chart-container {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      flex-wrap: wrap;
      width: 100%;
      position: relative;
      gap: 1rem;
      margin-bottom: 20px;
      padding-right: 22px;
      .chart-content {
        display: flex;
        border: 1px solid #fff;
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 10px 30px #00000015;
        border-radius: 15px;
        opacity: 1;
        margin: 10px;
        padding: 0px 20px;
        overflow: hidden;
        width: 100%;
        flex-direction: column;
        height: 350px !important;
        .chart_header_content {
          display: flex;
          flex-direction: row;
          align-items: center;
          .chart_header {
            color: #282828;
            font-size: 14px;
            margin-top: 22px;
            padding-bottom: 20px;
            font-weight: bold;
            width: 100%;
            max-width: max-content;
          }
        }
        .chart_header {
          color: #282828;
          font-size: 14px;
          margin-top: 22px;
          padding-bottom: 20px;
          font-weight: bold;
        }
        div {
          display: flex !important;
          width: 100% !important;
          max-width: 100% !important;
          overflow: hidden;
        }
        canvas {
          height: none !important;
        }
      }
      .table-content {
        display: flex;
        border: 1px solid #fff;
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 10px 30px #00000015;
        border-radius: 15px;
        opacity: 1;
        margin: 10px;
        padding: 0px 20px;
        overflow: auto;
        flex-direction: column;
        padding-bottom: 30px;
        .table-header {
          color: #282828;
          font-size: 14px;
          margin-top: 22px;
          padding-bottom: 20px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>


